<template>
    <div>
        <form class="simulator-table">
            <table class="table">
                <thead>
                    <tr>
                        <th width="180">Parcela</th>
                        <th width="50">Quantidade</th>
                        <th width="240">Valor</th>
                        <th width="150">1º Vencimento</th>
                        <th v-if="showInterest" width="160">Juros</th>
                        <th width="80" v-if="getInstallmentsTypeReadjust" >Reajuste</th>
                        <th width="3%">
                            <div  class="info" @mouseover="show = true" @mouseout="show = false">
                                <i class="fal fa-info-circle"></i>
                                <div v-if="show" class="tooltip">
                                    <h3>
                                        Aplicar Saldo Restante mudou de lugar!
                                    </h3>
                                    Agora você encontra essa função no ícone ao lado do valor da parcela (⟳ R$).
                                    Clique nele para redistribuir automaticamente o saldo restante para essa parcela.
                                </div>
						    </div>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <component
                        :is="tableItemComponent"
                        v-for="(item, index) in simulationSeries"
                        :key="item.id" 
                        :index="index"
                        :data="item"
                    />
                </tbody>
            </table>
        </form>
        <div class="buttons">
            <ui-button data-ui="'simulator-button-add-series'" design="primary md" @click="addSeries"><i class="fal fa-plus"/> Adicionar Parcela</ui-button>
        </div>
    </div>
</template>

<script>
    import { uiButton } from "@/components/ui/buttons"

    import { mapGetters } from 'vuex'

    import {  permissionsMixin } from '@/mixins'

    export default {
        name: 'ui-simulator-table',

        components: { uiButton },
        data() {
            return {
                show: false
            }
        },

        mixins: [ permissionsMixin ],

        computed: {
            ...mapGetters('simulation', {
                simulationSeries: 'getSeries',
                simulationConfig: 'getSimulationConfig',
                product: 'getProduct',
                simulationType:'getSimulationType',
                getInstallmentsTypeReadjust: 'getInstallmentsTypeReadjust',
            }),
            /**
             * Computed property que define o component de linha a ser utilizado para as
             * parcelas
             */
            tableItemComponent() {
                return this.product?.availability?.type === 'vertical'
                    ? () => import('../vertical-table-item')
                    : () => import('../simulator-table-item')
            },
            /**
             * Computed property que define se a coluna de seleção de juros será mostrada
             */
            showInterest() {
                return this.product?.availability?.type !== 'vertical' && 
                this.simulationConfig &&
                    parseInt(this.simulationConfig.interest)
            }
        },
        
        methods: {
            addSeries() {
                this.$store.dispatch('simulation/addSimulationSeries')
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>